module.exports = __webpack_public_path__ + "img/kma_gallery1.4a22dedb.jpg";